























import { defineComponent, ref, watch } from "@vue/composition-api";

import { Document } from "@/tools/msa/models";
import { format, parse } from "date-fns/esm";

interface Props {
  document: Document;
}

export default defineComponent({
  name: "DateInput",
  props: {
    document: { type: Object }
  },
  setup(props: Props) {
    const pending = ref<string | null>(
      props.document.date !== null
        ? format(parse(props.document.date, "M/d/y", new Date()), "y-M-d")
        : null
    );

    const isEditing = ref(false);

    const commit = () => {
      props.document.date =
        pending.value !== null
          ? format(parse(pending.value, "y-M-d", new Date()), "M/d/y")
          : null;
      isEditing.value = false;
    };

    const cancel = () => {
      isEditing.value = false;
      pending.value =
        props.document.date !== null
          ? format(parse(props.document.date, "M/d/y", new Date()), "y-MM-dd")
          : null;
    };

    watch(() => props.document, cancel);

    return {
      pending,
      isEditing,
      commit,
      cancel
    };
  }
});
